import styled from "styled-components"
import { BiMenuAltRight } from "react-icons/bi"
import { Modal } from "@mui/material"

export const MenuAltRight = styled(BiMenuAltRight)`
    color: var(--secundary-color);
    width: 25px;
    height: 25px;
    margin-bottom: 10px;
    margin-top: 10px;
    cursor: pointer;
`
export const Div = styled.div`
    display: none;

    @media (max-width: 1024px){
        width: 90%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
`

export const CModal = styled(Modal)`
    display: flex;
    justify-content: center;
    align-items: center;

    aside{
        display: flex;
        max-width: 320px;
        width: 80%;
    }

    button{
        color: white;
        z-index: 2000;
        position: relative;
        font-size: 22px;
        align-self: flex-start;
        top: 40px;
        left: 120px;
        background-color: transparent;
        border: none;
    }

    h3,h4,h5{
        color: var(--white-color);
        margin-bottom: 5px;
    }

    aside p {
        color: var(--white-color);
    }

    h4 span{
        color: var(--text-color);
        font-weight: 500;
    }

    @media (min-width: 1024px) {
        display: none;
    }
`